import { render, staticRenderFns } from "./OnboardingForm.vue?vue&type=template&id=38cac221&scoped=true"
import script from "./OnboardingForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingForm.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./OnboardingForm.vue?vue&type=style&index=0&id=38cac221&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cac221",
  null
  
)

export default component.exports